const ENDPOINTS = {
    debtCancellation: '/v1/credit/accounts/management/debt-cancellation'
};
export default ENDPOINTS;
